module.exports = __webpack_public_path__ + "static/img/productbook.4b7fc28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/productbook.png
// module id = jcil
// module chunks = 0